import operationHandler from './OperationHelper/OperationHandler';

export default {
    install: (app) => {

        app.config.globalProperties.$operationHandler = (value, opration, valueToCompare) => new operationHandler(value, opration, valueToCompare);
    },
};

